// frontend/src/assets/bookmakerLogos.js

import draftkings from './sportsbook_logos/draftkings.svg';
import fanduel from './sportsbook_logos/fanduel.svg';
import pointsbet from './sportsbook_logos/pointsbet.svg';
import betmgm from './sportsbook_logos/betmgm.svg';
import williamhill from './sportsbook_logos/william_hill.svg';
import circa from './sportsbook_logos/circa.svg';
import pinnacle from './sportsbook_logos/pinnacle.png';
import bookmaker from './sportsbook_logos/bookmaker.svg';
import betonline from './sportsbook_logos/betonline.svg';
import bovada from './sportsbook_logos/bovada.svg';
import action247 from './sportsbook_logos/action24_7.png';
import eighteighteightsports from './sportsbook_logos/888sports.png';
import betamerica from './sportsbook_logos/betamerica.png';
import betfred from './sportsbook_logos/betfred.png';
import betrivers from './sportsbook_logos/betrivers.png';
import borgata from './sportsbook_logos/borgata.svg';
import betwildwood from './sportsbook_logos/betwildwood.png';
import caesars from './sportsbook_logos/caesars.png';
import foxbet from './sportsbook_logos/foxbet.svg';
import fourwinds from './sportsbook_logos/four_winds.png';
import goldennugget from './sportsbook_logos/golden_nugget.svg';
import hardrock from './sportsbook_logos/hard_rock.png';
import parx from './sportsbook_logos/parx.svg';
import resorts from './sportsbook_logos/resorts.png';
import sugarhouse from './sportsbook_logos/sugarhouse.svg';
import superbook from './sportsbook_logos/superbook.png';
import tipico from './sportsbook_logos/tipico.svg';
import twinspires from './sportsbook_logos/twinspires.svg';
import unibet from './sportsbook_logos/unibet.svg';
import windcreek from './sportsbook_logos/wind_creek.svg';
import wynnbet from './sportsbook_logos/wynnbet.png';
import elitesportsbook from './sportsbook_logos/elite_sportsbook.png';
import playmavericksports from './sportsbook_logos/play_maverick_sports.png';
import espnbet from './sportsbook_logos/espn_bet.svg';
import ballybet from './sportsbook_logos/ballybet.svg';
import playup from './sportsbook_logos/playup.png';
import betway from './sportsbook_logos/betway.png';
import firekeepers from './sportsbook_logos/firekeepers.png';
import fubo from './sportsbook_logos/fubo.png';
import gambetdc from './sportsbook_logos/gambetdc.png';
import gunlake from './sportsbook_logos/gun_lake.svg';
import maximbet from './sportsbook_logos/maximbet.png';
import sbk from './sportsbook_logos/sbk.png';
import si from './sportsbook_logos/si.png';
// import unabated from './sportsbook_logos/unabated.svg'; // Commented out due to namespace issue
import fivedimes from './sportsbook_logos/5dimes.png';
import matchbook from './sportsbook_logos/matchbook.png';
import lowvig from './sportsbook_logos/lowvig.png';
import builder from './sportsbook_logos/builder.png';
import intertops from './sportsbook_logos/intertops.png';
import youwager from './sportsbook_logos/youwager.png';
import buckeye from './sportsbook_logos/buckeye.webp';
import thescore from './sportsbook_logos/thescore.webp';
import prophetexchange from './sportsbook_logos/prophet_exchange.png';
import sporttrade from './sportsbook_logos/sporttrade.png';
import sportsinteraction from './sportsbook_logos/sports_interaction.png';
import prizepicks from './sportsbook_logos/prizepicks.webp';
import underdogfantasy from './sportsbook_logos/underdog_fantasy.webp';
import threeet from './sportsbook_logos/3et.png';
import bet365 from './sportsbook_logos/bet365.svg';
import splashsports from './sportsbook_logos/splash_sports.png';
import draftkingspick6 from './sportsbook_logos/draftkings_pick6.webp';
import fanatics from './sportsbook_logos/fanatics.png';
import novig from './sportsbook_logos/novig.png';
import sleeper from './sportsbook_logos/sleeper.png';
import fliff from './sportsbook_logos/fliff.png';

export const bookmakerLogos = {
  'DraftKings': draftkings,
  'FanDuel': fanduel,
  'PointsBet': pointsbet,
  'BetMGM': betmgm,
  'William Hill': williamhill,
  'Circa': circa,
  'Pinnacle': pinnacle,
  'Bookmaker': bookmaker,
  'BetOnline': betonline,
  'Bovada': bovada,
  'Action24/7': action247,
  '888sports': eighteighteightsports,
  'BetAmerica': betamerica,
  'Betfred': betfred,
  'BetRivers': betrivers,
  'Borgata': borgata,
  'BetWildwood': betwildwood,
  'Caesars': caesars,
  'FoxBet': foxbet,
  'Four Winds': fourwinds,
  'Golden Nugget': goldennugget,
  'Hard Rock': hardrock,
  'Parx': parx,
  'Resorts': resorts,
  'Sugarhouse': sugarhouse,
  'SuperBook': superbook,
  'Tipico': tipico,
  'TwinSpires': twinspires,
  'Unibet': unibet,
  'Wind Creek': windcreek,
  'WynnBet': wynnbet,
  'Elite Sportsbook': elitesportsbook,
  'Play Maverick Sports': playmavericksports,
  'ESPN BET': espnbet,
  'BallyBet': ballybet,
  'PlayUp': playup,
  'BetWay': betway,
  'FireKeepers': firekeepers,
  'Fubo': fubo,
  'GamBetDC': gambetdc,
  'Gun Lake': gunlake,
  'MaximBet': maximbet,
  'SBK': sbk,
  'SI': si,
  // 'Unabated': unabated, // Commented out due to namespace issue
  '5Dimes': fivedimes,
  'Matchbook': matchbook,
  'LowVig': lowvig,
  'Builder': builder,
  'Intertops': intertops,
  'YouWager': youwager,
  'Buckeye': buckeye,
  'theScore': thescore,
  'Prophet Exchange': prophetexchange,
  'Sporttrade': sporttrade,
  'Sports Interaction': sportsinteraction,
  'PrizePicks': prizepicks,
  'Underdog Fantasy': underdogfantasy,
  '3et': threeet,
  'Bet365': bet365,
  'Splash Sports': splashsports,
  'DraftKings Pick6': draftkingspick6,
  'Fanatics': fanatics,
  'NoVig': novig,
  'Sleeper': sleeper,
  'Fliff': fliff,
};